module.exports = __webpack_public_path__ + "img/yx.645a0954.jpg";